// extracted by mini-css-extract-plugin
module.exports = {"product-card":"ProductCard_product-card__wHKx0","product-card__card":"ProductCard_product-card__card__UXQ0A"};